export const LoginErrorConstant = {
  mfaMissing: 'forbidden.2fa.missing',
  invalidCredentials: 'forbidden.invalid_credentials',
  passwordResetRequired: 'forbidden.password_reset_required',
  employeeOktaRequired: 'forbidden.employee_login_required',
  generalError: 'internal_server_error',
} as const
